module.exports = __webpack_public_path__ + "img/img2.0677c871.jpg";